module.exports = __webpack_public_path__ + "media/images/athletes/2174-e81a0d8a2adce744e30bf3d93a57a81f.png";